import './jumping-lama.less';

interface Props {
  className?: string
}

export default function JumpingLama(props: Props) {
  let className = "jumping-lama";
  if (props.className) {
    className += " " + props.className;
  }

  return <div className={className} />
}